module.exports = __webpack_public_path__ + "static/media/wordpress.f8b59fc4.png";